<template>
  <v-flex xs12 class="mt-5" v-if="order">
    <div
      style="border: 1px solid rgb(238, 238, 238); padding: 20px; height: 100%"
    >
      <template>
        <h3 class="mb-2">{{ $t('Delivery status') }}</h3>
        <div>
          <span>{{ $t('Order No') }} : </span><span>{{ order.id }}</span>
        </div>
        <div>
          <span>{{ $t('Status') }} : </span> <span>{{ $t(order.status) }}</span>
        </div>
        <div>
          <span>{{ $t('Paying by') }} : </span>
          <span>{{ $t(order.transactionid) }}</span>
        </div>

        <h3 class="mt-3">{{ $t('Product details') }}</h3>
        <template v-for="(product, oindex) in order.productdetail">
          <template>
            <v-layout wrap :key="'order_' + oindex">
              <v-flex sm1 xs2>
                <div class="ma-2">
                  <v-img
                    :src="
                      product.photourl
                        ? product.photourl
                        : require(`@/assets/img/products/default-photo.png`)
                    "
                    aspect-ratio="1"
                    alt
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>
                </div>
              </v-flex>
              <v-flex sm7 xs6 style="word-break: break-word">
                <div class="ma-2">
                  {{ product.name }} x {{ product.quantity }}
                  <template v-if="product.option"
                    >({{ product.option }})</template
                  >
                </div>
                <div
                  v-if="product.addon_json && product.addon_json.text"
                  class="pl-3 warning--text"
                >
                  <nl2br tag="span" :text="product.addon_json.text" />
                </div>
              </v-flex>
              <v-flex xs4 class="text-xs-right">
                <div class="ma-2">
                  {{ currencySign }}{{ product.price | decimalFormat }}
                </div>
              </v-flex>
            </v-layout>
          </template>
        </template>

        <template
          v-if="order.egg_crm_products && order.egg_crm_products.product"
        >
          <v-divider></v-divider>
          <v-layout wrap>
            <v-flex sm1 xs2>
              <div class="ma-2">
                <v-img
                  :src="
                    order.egg_crm_products.product.photourl ||
                    order.egg_crm_products.data.rewardImagePath
                  "
                  aspect-ratio="1"
                  alt
                  class="grey lighten-2"
                >
                  <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                    </v-layout>
                  </template>
                </v-img>
              </div>
            </v-flex>
            <v-flex sm7 xs6 style="word-break: break-word">
              <div class="ma-2">
                {{ order.egg_crm_products.product.name }} x
                {{ order.egg_crm_products.data.quantity }}
              </div>
            </v-flex>
            <v-flex xs4 class="text-xs-right">
              <div class="ma-2">Free</div>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
        </template>
      </template>

      <div>
        <v-layout v-if="order.egg_crm_phone_no">
          <v-flex>
            <div class="pa-2">{{ $t('หมายเลขสมาชิก') }}:</div>
          </v-flex>
          <v-flex>
            <div class="pa-2 text-xs-right">
              <span class="primary-color">{{ order.egg_crm_phone_no }}</span>
            </div>
          </v-flex>
        </v-layout>
        <v-layout v-if="order.total != null">
          <v-flex>
            <div class="pa-2">{{ $t('Subtotal') }}:</div>
          </v-flex>
          <v-flex>
            <div class="pa-2 text-xs-right">
              <span class="primary-color"
                >{{ currencySign
                }}{{
                  (order.total -
                    (order.shippingcharge ? order.shippingcharge : 0))
                    | decimalFormat
                }}</span
              >
            </div>
          </v-flex>
        </v-layout>
        <v-layout v-if="order.shippingcharge != null">
          <v-flex>
            <div class="pa-2">{{ $t('Shipping fee') }}:</div>
          </v-flex>
          <v-flex>
            <div class="pa-2 text-xs-right">
              <span class="primary-color"
                >{{ currencySign
                }}{{ order.shippingcharge | decimalFormat }}</span
              >
            </div>
          </v-flex>
        </v-layout>
        <v-layout v-if="order.discount > 0">
          <v-flex>
            <div class="pa-2">{{ $t('Discount') }}:</div>
          </v-flex>
          <v-flex>
            <div class="pa-2 text-xs-right">
              <span class="primary-color"
                >-{{ currencySign }}{{ order.discount | decimalFormat }}</span
              >
            </div>
          </v-flex>
        </v-layout>

        <!-- <v-layout v-if="jsonValue != null && jsonValue.promocode">
          <v-flex>
            <div class="pa-2">{{ $t("Coupon Code") }}:</div>
          </v-flex>
          <v-flex>
            <div class="pa-2 text-xs-right">
              <span class="primary-color">{{ jsonValue.promocode }}</span>
            </div>
          </v-flex>
        </v-layout> -->

        <v-layout v-if="order.vat_amount != null">
          <v-flex>
            <div class="pa-2">{{ $t('Vat') }}:</div>
          </v-flex>
          <v-flex>
            <div class="pa-2 text-xs-right">
              <span class="primary-color"
                >{{ currencySign }}{{ order.vat_amount | decimalFormat }}</span
              >
            </div>
          </v-flex>
        </v-layout>

        <v-layout v-if="order.amount != null">
          <v-flex>
            <div class="pa-2">{{ $t('grand_total') }}:</div>
          </v-flex>
          <v-flex>
            <div class="pa-2 text-xs-right">
              <span class="primary-color"
                >{{ currencySign }}{{ order.amount | decimalFormat }}</span
              >
            </div>
          </v-flex>
        </v-layout>
      </div>
      <v-divider />

      <v-layout>
        <v-flex class="pa-2">
          <span style="vertical-align: middle">{{ $t('Delivery by') }} :</span>
          <img
            v-if="order.shippingtype == 'normal'"
            src="../../assets/img/shipping/normal_charge_logo.png"
            alt
            class="responsive-img"
            style="max-height: 50px"
          />
          <img
            v-else-if="order.shippingtype == 'ems'"
            src="../../assets/img/shipping/ems_charge_logo.png"
            alt
            class="responsive-img"
            style="max-height: 50px"
          />
          <img
            v-else-if="order.shippingtype == 'kerry'"
            src="../../assets/img/shipping//kerry_charge_logo.png"
            alt
            class="responsive-img"
            style="max-height: 50px"
          />
          <span v-else-if="order.shippingtype == 'ขนส่งบริษัท'">
            {{ order.shippingtype }}
          </span>
          <template v-else>
            <template v-if="order.shippingtype">
              <img
                v-if="order.shippingtype !== 'googlemap_charge'"
                :src="
                  require('../../assets/img/shipping/' +
                    (order.shippingtype.includes('other')
                      ? 'other_charge'
                      : order.shippingtype) +
                    '_logo.png')
                "
                :alt="order.shippingtype + 'logo'"
                style="max-height: 50px"
              />
              <span v-else> {{ order.shippingtype }}</span>
              <div v-if="order.shippingtype == 'cod_charge'" class="caption">
                {{ $t('cod_charge') }}
              </div>
            </template>
          </template>
        </v-flex>
      </v-layout>
      <v-divider />
      <template v-if="pageProfile.page_receipt_status">
        <v-layout v-if="tax_address_json">
          <v-flex class="pa-2" v-if="tax_address_json.invoice_date">
            <div class="caption">
              <template>{{ $t('date_tax') }}</template>
            </div>
            {{ tax_address_json.invoice_date }}
          </v-flex>
        </v-layout>
        <v-layout v-if="tax_address_json && tax_address_json.tax_address">
          <v-flex class="pa-2">
            <div class="caption">
              <template>{{ $t('Address (Receipt/ Tax invoice)') }}</template>
            </div>
            {{ tax_address_json.tax_address }}
          </v-flex>
        </v-layout>
        <v-layout v-if="tax_address_json && tax_address_json.tax_id">
          <v-flex class="pa-2">
            <div class="caption">
              <template>{{ $t('tax_id') }}</template>
            </div>
            {{ tax_address_json.tax_id }}
          </v-flex>
        </v-layout>
      </template>
    </div>

    <template
      v-if="
        (!order.created_by.includes('admin') && order.payment == 'transfer') ||
        (order.created_by.includes('admin') &&
          order.payment == 'transfer' &&
          order.status === 'paid') ||
        (order.created_by.includes('admin') &&
          order.payment == 'transfer' &&
          order.status === 'ordered')
      "
    >
      <template
        v-if="
          (!order.created_by.includes('admin') &&
            order.payment == 'transfer' &&
            order.status === 'pending') ||
          (!order.created_by.includes('admin') &&
            order.payment == 'transfer' &&
            order.status === 'ordered') ||
          (order.created_by.includes('admin') &&
            order.payment == 'transfer' &&
            order.status === 'pending') ||
          (order.created_by.includes('admin') &&
            order.payment == 'transfer' &&
            order.status === 'ordered')
        "
      >
        <div class="hr"></div>
        <a
          href="javascript:void(0);"
          @click="showDetail = !showDetail"
          style="text-decoration: none"
        >
          <div class="text-xs-center" style="margin: 10px auto">
            {{ $t('Click to view slip') }}
            <v-icon v-if="!showDetail" style="font-size: 18px"
              >mdi-chevron-down</v-icon
            >
            <v-icon v-else style="font-size: 18px">mdi-chevron-up</v-icon>
          </div>
        </a>
        <div
          v-show="showDetail"
          style="
            margin-bottom: 0;
            background: rgb(253, 253, 253);
            border-bottom-left-radius: 10px;
          "
        >
          <template v-if="showDetail">
            <upload-file
              name="paymentSlipImage"
              :data-vv-as="$t('Payment Slip Image')"
              v-model="order.note"
              @verifyDataClick="verifyDataClick"
            ></upload-file>
          </template>
        </div>
      </template>
      <div
        v-else
        style="
          position: relative;
          overflow: hidden;
          background: rgb(238, 238, 238);
          border-radius: 5px;
          text-align: center;
        "
      >
        <img
          v-if="order.note"
          :src="order.note"
          alt="Upload Product Image"
          style="height: 250px; margin-bottom: -10px"
        />
      </div>
    </template>
  </v-flex>
</template>

<script>
import UploadFile from '@/components/UploadFile.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  props: {
    productDetail: {
      default: []
    }
  },
  components: {
    UploadFile
  },
  computed: {
    ...mapGetters({
      pageProfile: 'getPageProfile',
      currencySign: 'currencySign'
    })
  },
  data() {
    return {
      showDetail: true,
      showProduct: false,
      order: null,
      shippingValue: '',
      tax_address_json: null
    }
  },
  mounted() {
    this.productDetail.productdetail = JSON.parse(
      this.productDetail.productdetail
    )
    this.order = this.productDetail
    if (
      this.order.address_json &&
      typeof this.order.address_json === 'string'
    ) {
      this.tax_address_json = JSON.parse(this.order.address_json)
      if (!this.tax_address_json.invoice_date) {
        this.tax_address_json.invoice_date = moment(
          this.order.timestamp
        ).format('YYYY-MM-DD')
      }
    }
    // this.getShippingType();
  },
  methods: {
    verifyDataClick(param) {
      const vm = this
      vm.$emit('update:verifyData', param)
    }
    // getShippingType() {
    //   var shippingType = "";
    //   try {
    //     var jsondata = JSON.parse(this.order.shippingtype);
    //     shippingType = jsondata.type ? jsondata.type : "";
    //   } catch (error) {
    //     shippingType = this.order.shippingtype;
    //   }
    //   var shippingValue = this.shippingOptions.find((el) => {
    //     return el.name.includes(shippingType) || (el[4] && el[4].includes(shippingType));
    //   });
    //   this.shippingValue = shippingValue ? shippingValue.name : "";
    //   this.shippingType = shippingValue;
    // },
  }
}
</script>

<style lang="scss" scoped></style>
